import Vue from 'vue';
import App from './App.vue';
import axios from 'axios';
import VueAxios from 'vue-axios';
import router from './router';
import store from './store';
import './registerServiceWorker';
import BootstrapVue from 'bootstrap-vue';
import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap-vue/dist/bootstrap-vue.css';
import './styles/fonts.scss';
import DateRangePicker from "@gravitano/vue-date-range-picker";
import VueSimpleAlert from "vue-simple-alert";

Vue.use(VueSimpleAlert);

Vue.config.productionTip = false;

// use the plugin
Vue.use(DateRangePicker);

Vue.use(BootstrapVue);
Vue.use(VueAxios, axios);

import HighchartsVue from 'highcharts-vue';
import Highcharts from 'highcharts';
import exporting from 'highcharts/modules/exporting';
import exportData from 'highcharts/modules/export-data';
import JsonExcel from "vue-json-excel";

Vue.component("downloadExcel", JsonExcel);

exporting(Highcharts);
exportData(Highcharts);

Vue.use(HighchartsVue, { Highcharts });

Vue.config.productionTip = false;

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount('#app');